import { useEffect, useState } from "react";

const useReview = () => {
  const [reviews, setReview] = useState([]);
  useEffect(() => {
    fetch("reviewdata.json")
      .then((res) => res.json())
      .then((data) => setReview(data));
  }, [reviews]);
  return [reviews, setReview];
};

export default useReview;
